class SocialVideosSlider {
  constructor(container) {
    this.container = container;
    this.splideInstance = null;
    this.btnNext = document.getElementById('nex-button');
    this.btnPrev = document.getElementById('prev-button');
    this.init();
  }

  init() {
    this.handleSplideSlider();
    this.bindNavigationButtons();
    this.setupVideoControls();
  }

  handleSplideSlider() {
    const videoSlider = this.container;

    if (videoSlider) {
      if (this.splideInstance) {
        this.splideInstance.destroy(true);
      }

      this.splideInstance = new Splide(videoSlider, {
        type: 'slide',
        perPage: 3,
        gap: 27,
        perMove: 1,
        mobileFirst: true,
        autoplay: false,
        arrows: true,
        pagination: true,
        speed: 1000,
        breakpoints: {
          1024: {
            perPage: 2,
            centerMode: true,
            variableWidth: false,
          },
          732: {
            perPage: 1,
            centerMode: true,
            variableWidth: false,
          },
        },
      }).mount();
    }
  }

  bindNavigationButtons() {
    const btnNext = document.getElementById('nex-button');
    const btnPrev = document.getElementById('prev-button');

    [btnNext].forEach(button => {
      if (button) button.addEventListener('click', () => {
        this.splideInstance.go('+1');
      });
    });

    [btnPrev].forEach(button => {
      if (button) button.addEventListener('click', () => {
        this.splideInstance.go('-1');
      });
    });
  }

  setupVideoControls() {
    const videos = document.querySelectorAll('.social-videos-container video');

    videos.forEach((video, index) => {
      const playButton = video.closest('.splide__slide').querySelector('.social-play-button');
      const thumbnail_image = video.closest('.video-container').querySelector('.thumbnail');

      video.addEventListener('click', () => this.toggleVideo(video, playButton));
      playButton.addEventListener('click', () => this.toggleVideo(video, playButton));
      thumbnail_image?.addEventListener('click', () => this.toggleVideo(video, playButton));

      video.addEventListener('play', () => {
        playButton.style.display = 'none';
        thumbnail_image.style.display = 'none';
      });

      video.addEventListener('pause', () => {
        playButton.style.display = 'block';
      });
    });
  }

  toggleVideo(video, playButton) {
    const allVideos = document.querySelectorAll('.social-videos-container video');

    if (video.paused) {
      allVideos.forEach(v => {
        v.pause();
        const button = v.closest('.splide__slide').querySelector('.social-play-button');
        button.style.display = 'block';
      });
      video.play();
      video.muted = false;
      playButton.style.display = 'none';
    } else {
      video.pause();
      video.muted = true;
      playButton.style.display = 'block';
    }
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const socialVideosSection = document.querySelector('.social-videos-container[social-reviews-slider]');

  if (socialVideosSection) {
    new SocialVideosSlider(socialVideosSection);
  }
});

document.addEventListener('shopify:section:load', (event) => {
  const socialVideosSection = event.target.querySelector('.social-videos-container[social-reviews-slider]');

  if (socialVideosSection) {
    new SocialVideosSlider(socialVideosSection);
  }
});
